import { render, staticRenderFns } from "./ScrollProgressBar.vue?vue&type=template&id=52f83a4a&"
import script from "./ScrollProgressBar.vue?vue&type=script&lang=js&"
export * from "./ScrollProgressBar.vue?vue&type=script&lang=js&"
import style0 from "./ScrollProgressBar.vue?vue&type=style&index=0&id=52f83a4a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports